<template>
  <v-container class="px-1">
    <v-form ref="cronogramaFilterForm">
      <v-row  class="px-0">
        <v-col class="pt-0 pb-0 px-2" cols="12" sm="6" md="2">
          <label>Data entre</label>
          <v-menu
            ref="dtI"
            v-model="dtI"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateIFormatted"
                dense
                v-mask="'##/##/####'"
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="dateI = parseDate(dateIFormatted)"
                :rules="[formRules.typeDateFormated]"
              ></v-text-field>
            </template>
            <v-date-picker color="primary"  v-model="dateI" no-title scrollable></v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="pt-0 pb-0 px-2" cols="12" sm="6" md="2">
          <label>até</label>
          <v-menu
            ref="dtF"
            v-model="dtF"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFFormatted"
                v-mask="'##/##/####'"
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                dense
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="dateF = parseDate(dateFFormatted)"
                :rules="[formRules.typeDateFormated]"
              ></v-text-field>
            </template>
            <v-date-picker color="primary"  v-model="dateF" no-title scrollable></v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="pt-0 pb-0 px-2" cols="2">
            <label>Pesquisar por</label>
            <v-select
                v-model="formData.typeSearch"
                :items="typeSearchList"
                item-value="id"
                item-text="descricao"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                outlined
                @change="formData.nota_fiscal = null; formData.protocolo = null; formData.num_lote = null;"
            ></v-select>
          </v-col>
          <v-col class="pt-5 pb-0 px-2" cols="3">
            <v-text-field
                v-model="formData[formData.typeSearch]"
                prepend-inner-icon="mdi-magnify"
                :placeholder="labelBuscaGenerica[formData.typeSearch]"
                single-line
                outlined
                dense
                hide-details
                :disabled="!formData.typeSearch"
            ></v-text-field>
          </v-col>
        <v-col class="pt-0 pb-0 px-2" cols="12" sm="6" md="3" v-if="isComplementar">
            <v-checkbox
            class="pa-0 ma-0 pt-4"
             style="font-size: 14px !important"
            v-model="formData.abertos"
            small
            label="Apenas cronogramas com complementação em aberto."
            hide-details
          ></v-checkbox>
        </v-col>
         <v-col class="pt-0 pb-0 px-2" cols="12" sm="6" md="3" v-else>
           <v-checkbox
           style="font-size: 14px !important"
            class="pa-0 ma-0 pt-4"
            small
            v-model="formData.complementar"
            label="Apenas cronogramas complementares"
            hide-details
          ></v-checkbox>
         </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0 pb-0 px-2" cols="12" sm="6" md="2">
          <label>Prestador</label>
          <v-select
            v-model="formData.prestador_id"
            :items="prestadoresFilter"
            item-value="id"
            item-text="prest_nome"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
            @change="changePrestador()"
          ></v-select>
        </v-col>
        <v-col class="pt-0 pb-0 px-2" cols="12" sm="6" md="2">
          <label>Operadora</label>
          <v-select
            v-model="formData.operadora_ans_id"
            :items="operadorasFilter"
            item-value="id"
            item-text="oper_nome"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col class="pt-0 pb-0 px-2" cols="12" sm="6" md="2">
          <label>Responsável</label>
          <v-select
            v-model="formData.owner_id"
            :items="responsaveisFilter"
            item-value="Id"
            item-text="UserName"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col class="pt-0 pb-0 px-2" cols="12" sm="6" md="2" v-if="!isComplementar">
          <label>Status</label>
          <v-select
            v-model="formData.card_name"
            :items="statusFilter"
            item-value="id"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          >
            <template v-slot:item="data">
              <template v-if="(typeof data.item !=='object')">
                <v-list-item-content v-text="data.item"></v-list-item-content>
              </template>
              <template v-else>
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.descricao"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-avatar size="20" :color="data.item.color" v-if="data.item.color">
                </v-list-item-avatar>
              </template>
            </template>
          </v-select>
        </v-col>
        <v-col class="pt-0 pb-0 px-2">
        <v-btn
          class="mt-5"
          height="32px"
          small
          depressed
          color="primary"
          @click="sendFilter()"
        >Filtrar</v-btn>
        <v-btn
          class="mt-5 ml-4"
          height="31px"
          small
          depressed
          outlined
          color="primary"
          @click="clearFilters()"
        >Limpar Filtros</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mask } from 'vue-the-mask'
import { mapState } from "vuex"
export default {
  directives: {
    mask
    },
  beforeCreate(){
    this.monName = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"]
  },
  data(){
    return {
      cookieFilter: null,
      prest: null,
      formData: {
        abertos: null,
        card_name: null,
        complementar: null,
        dt_faturamento_fim: null,
        dt_faturamento_ini: null,
        modulo_operadora: "faturamento",
        nota_fiscal: null,/* novo filtro */
        num_lote: null, /* novo filtro */
        operadora_ans_id: null,
        owner_id: null,
        prestador_id: null,
        protocolo: null, /* novo filtro */
        typeSearch: null
      },
      dateF: null,
      dateFFormatted: null,
      dateI:null,
      dateIFormatted: null,
      dtI: false,
      dtF: false,
      prestadoresFilter:[],
      operadorasFilter:[],
      responsaveisFilter: [],
      labelBuscaGenerica:{
        nota_fiscal: 'Número da nota fiscal',
        protocolo: 'Número do protocolo',
        num_lote: 'Número do lote'
      },
      monName: [],
      statusFilter: [
         {
        id: null,
        descricao: 'Selecione',
        color: null,
         },
      {
        id: "Concluidos",
        descricao: `Concluído em ${this.monName[(new Date).getMonth()]}/${(new Date).getFullYear().toString()}`,
        color: "#32B88B",
      },{
        id: "Fechados",
        descricao: "Concluído",
        color: "#32B88B",
      },{
        id: "AConcluir",
        descricao: "Aguardando conclusão",
        color: "#B2B842",
      },{
        id: "Processando",
        descricao: "Em processamento (envio automático)",
        color: "#4A4A4A",
      },{
        id: "ProcessandoManual",
        descricao: "Em processamento (envio manual)",
        color: "#4A4A4A",
      },{
        id: "NaoIniciados",
        descricao: "Não iniciado",
        color: "#979797",
      },{
        id: "Critica",
        descricao: "Com crítica",
        color: "#D0021B",
      },{
        id: "AEnvio",
        descricao: "Aguardando transmissão",
        color: "#FC5F17",
      },{
        id: "Atrasados",
        descricao: "Em Atraso",
        color: "#FFA500",
      }],
      typeSearchList: [
        {id: null, descricao: 'Selecione'},
        {id: 'nota_fiscal', descricao: 'Nota fiscal'},
        {id: 'protocolo', descricao: 'Protocolo'},
        {id: 'num_lote', descricao: 'Nº do lote'}
      ],
      typeSearch: null
    }
  },
  computed: {
    ...mapState({
      formRules: state => state.formRules
    }),
  },  
  methods: {
    sendFilter(){
      if(this.$refs.cronogramaFilterForm.validate()){
        this.updateFilter(this.formData, null)
      }
    },
    clearFilters(){
      this.dateFFormatted = null;
      this.dateIFormatted = null;
      this.formData.nota_fiscal = null;
      this.formData.num_lote = null;
      this.formData.protocolo = null;
      this.formData.typeSearch = null;
      this.formData.dt_faturamento_fim = null;
      this.formData.dt_faturamento_ini = null;
      this.formData.card_name = null;
      this.formData.owner_id = null;
      this.formData.operadora_ans_id = null;
      this.formData.modulo_operadora = "faturamento"
      if (this.prestadoresFilter.length>1) {
        this.formData.prestador_id = null;
      }
      this.updateFilter(this.formData, null)
    },
    changePrestador(){
      this.formData.owner_id = null
      this.formData.operadora_ans_id = null
      this.formData.modulo_operadora = "faturamento"
      this.getResponsaveis(this.formData)
      this.getOperadoras(this.formData)
    },
    formUpdate(){
      this.$store.dispatch('faturamento/getFilter', "cronogramaFilter")
    .then( resp => {
      let flt = resp? resp : {}
      this.formData.modulo_operadora = "faturamento"
      if(flt){
        this.dateFFormatted = this.formatDate(flt.dt_faturamento_fim)
        this.dateIFormatted = this.formatDate(flt.dt_faturamento_ini)
        this.formData = Object.assign(this.formData, flt)
        if(this.formData.prestador_id) {
          if (!this.controlResponsavel) {
            this.getResponsaveis(this.formData)
            this.formData.owner_id = flt.owner_id
          }
          this.getOperadoras(this.formData)
        }
      } else {
        this.getOperadoras(this.formData)
        this.getResponsaveis(this.formData)
      }
      this.prestadorId(this.formData.prestador_id)
      this.updateFilter(this.formData, 1)
      })
    },
  },
  props: {
    controlResponsavel: Boolean,
    filter: Object,
    formatDate: Function,
    updateFilter: Function,
    getOperadoras: Function,
    getResponsaveis: Function,
    operadoras: Array,
    parseDate: Function,
    prestadores: Array,
    responsaveis: Array,
    userData: Object,
    prestadorId: Function,
    isComplementar: { type: Boolean, default: false }
  },
  mounted() {
    this.$store.dispatch('faturamento/getFilter', "cronogramaFilter").then(resp=>{
      
      let flt = resp? resp : this.filter 
      if(flt && !this.isComplementar){
        this.dateFFormatted = this.formatDate(flt.dt_faturamento_fim)
        this.dateIFormatted = this.formatDate(flt.dt_faturamento_ini)
        this.formData = Object.assign(this.formData, flt)
        if(this.formData.prestador_id) {
          if (!this.controlResponsavel) {
            this.getResponsaveis(this.formData)
            this.formData.owner_id = flt.owner_id
          }
          this.getOperadoras(this.formData)
        }
        this.formData.num_lote = flt.num_lote;
        this.formData.nota_fiscal = flt.nota_fiscal;
        this.formData.protocolo = flt.protocolo;
        this.formData.typeSearch = flt.typeSearch;
        
      } else {
        this.clearFilters()
        let {modulo_operadora} = this.formData
        this.getOperadoras({modulo_operadora})
        this.getResponsaveis(this.formData)
      }
      this.prestadorId(this.formData.prestador_id)
      
      this.updateFilter(flt, null)
    })
  },
  watch: {
    dateF(val){
      if (!val) {
        this.dateFFormatted = null
      } else {
        if (!!this.dateI && Date.parse(this.dateI) > Date.parse(val)){
          this.dateI = val
        }
        this.dateFFormatted = this.formatDate(val)
      }
    },
    dateFFormatted(val){
      this.formData.dt_faturamento_fim = this.parseDate(val)
    },
    dateI(val){
      if (!val) {
        this.dateIFormatted = null
      } else {
        if (!!this.dateF && Date.parse(this.dateF) < Date.parse(val)){
          this.dateF = val
        }
        this.dateIFormatted = this.formatDate(val)
      }
    },
    dateIFormatted(val){
      this.formData.dt_faturamento_ini = this.parseDate(val)
    },
    prestadores:{
      deep: true,
      handler(val){
        this.prestadoresFilter = Array.from(val)
        if(this.prestadoresFilter.length==1){
          this.formData.prestador_id = this.prestadores[0].id
        } else {
          this.prestadoresFilter.unshift({id: null, prest_nome: "Selecione"})
        }
      }
    },
    operadoras:{
      deep: true,
      handler(val){
        this.operadorasFilter = Array.from(val)
        this.operadorasFilter.unshift({id: null, oper_nome: "Selecione"})
      }
    },
    responsaveis:{
      deep: true,
      handler(val){
        this.responsaveisFilter = Array.from(val)
        this.responsaveisFilter.unshift({Id: null, UserName: "Selecione"})
      }
    }
  },
};
</script>
